import { Middleware, MiddlewareAPI, Dispatch, AnyAction } from 'redux';
import { ActionTypes as NavBarActionTypes } from 'ha/modules/NavBar/actions';
import { getIsIos, getIosVersion } from '../selectors';

const fixCssClassName = 'iosBugFixCaret';
const iosVersionRange = [11, 11.3];
const actionsToOpenModal = [NavBarActionTypes.SHOW_MODAL];
const actionsToHideModal = [NavBarActionTypes.HIDE_MODAL];
const actionsToHandle = [...actionsToOpenModal, ...actionsToHideModal];

export default (element: HTMLElement): Middleware => (
  // We have to declare type parameter as any for now
  // because we don't have type for out store state yet
  // FIXME: when we have type for store state
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  store: MiddlewareAPI<any>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) => (next: Dispatch<AnyAction>) => (action: any) => {
  if (!actionsToHandle.includes(action.type)) {
    return next(action);
  }

  const state = store.getState();
  const isIos = getIsIos(state);
  const iosVersion = getIosVersion(state);

  if (
    !isIos ||
    iosVersion < iosVersionRange[0] ||
    iosVersion >= iosVersionRange[1]
  ) {
    return next(action);
  }

  if (actionsToOpenModal.includes(action.type)) {
    element.classList.add(fixCssClassName);
  }

  if (actionsToHideModal.includes(action.type)) {
    element.classList.remove(fixCssClassName);
  }

  return next(action);
};
